/* eslint-disable no-nested-ternary */
import React from 'react';
import './App.scss';
import {Link, Switch} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import EmailInput from './components/EmailInput/EmailInput';
import Main from './components/Main/MainContainer';
import Verification from './components/Verification/Verification';
import Users from './components/Users/UsersContainer';
import routes from './common/routes/routes';
import {Status} from './common/const/const';
import PrivateRouter from './components/PrivateRouter/PrivateRouter';
import AuthService from './components/AuthService/AuthService';
import Loader from './components/Loader/Loader';
import LogOutButton from './components/LogOutButton/LogOutButton';
import ErrorView from './components/ErrorView/ErrorView';
import {logOut, sendError} from './common/redux/actions'
import NotFound from './components/NotFound/NotFound';
import Socket from './common/api/socket';

const authService = new AuthService();
Socket.getInstance().startSocket();

function App() {
    const [status, setStatus] = React.useState(undefined);
    const globError = useSelector(state => state.main.error);
    const dispatch = useDispatch();
    const unauthorizedStatus = 401;

    const switchStatus = React.useCallback(newStatus => {
        setStatus(newStatus);
    }, []);

    const checkAuthorization = React.useCallback(async () => {
        if (authService.getAccessToken() !== null) {
            await authService.checkAutorization()
                .then(() => {
                    setStatus(Status.AUTHORIZED);
                })
                .catch(error => {
                    if (error.response.status === unauthorizedStatus) {
                        authService.refreshAccessToken().then(() => {
                            setStatus(Status.AUTHORIZED);
                        }).catch(nextError => {
                            authService.removeTokens();
                            dispatch(logOut());
                            setStatus(Status.UN_AUTHORIZED);
                        })
                    }
                })
        } else {
            setStatus(Status.UN_AUTHORIZED);
        }
    }, [dispatch]);

    React.useEffect(() => {
        checkAuthorization();
    }, [checkAuthorization]);

    return (
        <div className="App__main">
            {globError && <ErrorView error={globError} />}
            {status === Status.AUTHORIZED && <LogOutButton authService={authService} switchStatus={switchStatus}  />}
            {status === Status.AUTHORIZED && <Link to={routes.MAIN}>
                <button type="button" className="MainButton__main">
                    <span>Главная</span>
                </button>
            </Link>}
            {status === Status.AUTHORIZED && <Link to={routes.USERS}>
                <button type="button" className="UsersButton__main">
                    <span>Пользователи</span>
                </button>
            </Link>}
            {status === undefined && <Loader />}
            {status !== undefined && <Switch>
                <PrivateRouter exact path={routes.MAIN} component={Main} status={status} componentProps={{authService}}/>
                <PrivateRouter exact path={routes.LOGIN} component={EmailInput} status={status} componentProps={{switchStatus, authService}}/>
                <PrivateRouter exact path={routes.VERIFY} component={Verification} status={status} componentProps={{switchStatus, authService}} />
                <PrivateRouter exact path={routes.USERS} component={Users} status={status} componentProps={{authService}} />

                <PrivateRouter exact path={routes.OTHER} component={NotFound} />
            </Switch>}
        </div>
    );
}

export default App;
